// utils/audioPlayer/orderSounds.ts — bunyi pesanan: cash register (fisik)
// + ding (digital). Fallback oscillator bila mp3 gagal load supaya tetap bunyi.
import { getAudioContext, loadBuffer, playBeepFallback } from './context.js';

const _cashCache = { buffer: null as AudioBuffer | null };
const _dingCache = { buffer: null as AudioBuffer | null };

async function playCachedOrBeep(path: string, cache: { buffer: AudioBuffer | null }, volume: number): Promise<void> {
  const ctx = await getAudioContext();
  if (ctx.state !== 'running') {
    console.warn('[audio] AudioContext suspended saat order masuk — klik di mana saja dulu.');
  }
  const buffer = await loadBuffer(path, cache);
  if (buffer) {
    const source = ctx.createBufferSource();
    const gainNode = ctx.createGain();
    source.buffer = buffer;
    gainNode.gain.value = volume;
    source.connect(gainNode);
    gainNode.connect(ctx.destination);
    source.start(0);
    return;
  }
  // File mp3 hilang/gagal decode → fallback oscillator supaya tetap bunyi.
  await playBeepFallback(volume);
}

export async function playPhysicalSound(volume: number = 0.8): Promise<void> {
  try {
    await playCachedOrBeep('/sounds/cash-register-v2.mp3', _cashCache, volume);
  } catch (error) {
    console.error('Error playing physical sound:', error);
  }
}

export async function playDigitalSound(volume: number = 0.8): Promise<void> {
  try {
    await playCachedOrBeep('/sounds/digital-order-ding.mp3', _dingCache, volume);
  } catch (error) {
    console.error('Error playing digital sound:', error);
  }
}

export async function playSound(volume: number = 0.8): Promise<void> {
  await playPhysicalSound(volume);
}
